import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-587b6e4b")

_pushScopeId("data-v-587b6e4b")
const _hoisted_1 = { class: "dialog-block" }
const _hoisted_2 = { class: "dialog" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "msg" }, [
  /*#__PURE__*/_createTextVNode("Your information has been sent,"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("we will contact you soon.")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, "Close")
    ])
  ]))
})